import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import axios from 'axios';
import * as yup from 'yup';
import { UserType } from 'helpers/enums';

interface IAdminUserContext {
    isLoading: boolean
    isSaving: boolean
    user: User
    userSchema: any

    saveUser: (values: User) => Promise<void>
}

let userSchema = yup.object({
    id: yup.string().default(''),
    email: yup.string().default('').required().label("Email"),
    firstName: yup.string().required().default('').label("Firstname"),
    lastName: yup.string().required().default('').label("Lastname"),
    userType: yup.string().default('').required().label("User type"),
    company: yup.string().default(''),
    isSerialNumbersEditor: yup.boolean().default(false),
    countryCode: yup.string()
        .when("userType", {
            is: (value: string) => value === UserType.External,
            then: yup.string().default('').required().label("Country")
        }).default('')
})

type User = yup.InferType<typeof userSchema>;

export let adminUserContext = React.createContext({} as IAdminUserContext);

let { Provider } = adminUserContext;

let AdminUserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let history = useHistory();

    let isNew = location.pathname.includes("addnew");

    let [isLoading, setLoading] = useState(isNew === false);
    let [isSaving, setSaving] = useState(false);

    let [user, setUser] = useState<User>(userSchema.getDefault());


    useEffect(() => {
        if (isNew === false)
            getUser();
    }, [id])


    let getUser = async () => {
        try {
            let res = await axios.get('/api/AdminUser/GetAdminUser', { params: { id } });
            setUser(res.data.item);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let saveUser = async (values: User) => {
        try {
            setSaving(true);
            await axios.post('/api/AdminUser/SaveAdminUser', values);
            history.push('/adminusers');

        } catch (err) {
            setSaving(false);
        }
    }


    return (
        <Provider
            value={{
                isLoading,
                isSaving,
                user,
                userSchema,

                saveUser
            }}
        >
            {children}
        </Provider>
    )
}

export default AdminUserProvider;